import Alert from '@mui/material/Alert'
import { type SyntheticEvent, useEffect, useState } from 'react'
import { Collapse, Typography } from '@mui/material'
import { InfoOutlined } from '@mui/icons-material'
import { PlanOrganizationTaskStatus } from '../../../models/PlanOrganizationTask'

interface Props {
  status?: PlanOrganizationTaskStatus
}
export const LockedBanner = (props: Props): JSX.Element => {
  const showLockedBanner = (status?: PlanOrganizationTaskStatus): boolean => [PlanOrganizationTaskStatus.Submitted, PlanOrganizationTaskStatus.Accepted, PlanOrganizationTaskStatus.ReadyToSubmit, PlanOrganizationTaskStatus.UpdatesSubmitted].includes(status ?? '' as PlanOrganizationTaskStatus)
  const [open, setOpen] = useState(false)

  useEffect(() => {
    setOpen(showLockedBanner(props.status))
  }, [props.status])

  const handleClose = (event: SyntheticEvent): void => {
    event.stopPropagation()

    setOpen(false)
  }

  return <Collapse in={open} unmountOnExit>
    <Alert
      data-testid='lockedBanner'
      sx={{
        backgroundColor: 'var(--blue-500)',
        color: 'var(--white)',
        alignItems: 'center',
        mb: '20px',
        borderRadius: '12px',
        padding: '16px 16px 16px 32px'
      }}
      onClose={handleClose}
      icon={<InfoOutlined sx={{ width: '26px', height: '26px', color: 'var(--white)' }} />}
    >
      <Typography fontSize='18px' fontWeight='500' color='inherit'>
        These pages are under review. Editing is disabled, but you can still view the content.
      </Typography>
    </Alert>
  </Collapse>
}
